module.exports = __webpack_public_path__ + "static/media/6.459485b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/6.png
// module id = 1286
// module chunks = 0